module.exports = __webpack_public_path__ + "static/media/about-justact.a9b32619.png";